import { Progress } from "./progress";
import { usePage } from "@tree-company/tree-query";
import clsx from "clsx";
import { useContext, useEffect, useRef } from "react";
import { LocaleContext } from "./localization_wrapper";

function stepForPageKey(key) {
  if (key.startsWith("action")) {
    return 1;
  } else if (key.startsWith("comment") || key === "name") {
    return 2;
  } else if (key === "sociodemo") {
    return 3;
  } else if (key === "like" || key === "optin") {
    return 4;
  }
}

export function PageComponent({
  handleSave,
  page,
  children,
  onPreviousPage,
  className,
}) {
  const { title, description, htmlAttributes, key } = usePage(page);
  const i18n = useContext(LocaleContext);
  const elementRef = useRef();

  // Make sure the browsers back button has the same effect as our back button
  useEffect(() => {
    // If the previous history entry was a string, we already track history within the form
    // in that case, we can use `replaceState`
    // If not, we need to use `pushState` so that we can distinguish our history states from react router dom
    if (typeof window.history.state === "string") {
      window.history.replaceState(key, "", window.location.toString());
    } else {
      window.history.pushState(key, "", window.location.toString());
    }

    const goBack = (event) => {
      event.preventDefault();
      onPreviousPage();
    };
    window.addEventListener("popstate", goBack, { once: true });
    return () => window.removeEventListener("popstate", goBack, { once: true });
  }, [key]);

  useEffect(() => {
    // If our context has defined fathom, we send fake pages with the current step of the form
    if (window.fathom) {
      const locationWithKey = new URL(window.location);
      locationWithKey.pathname += `/${key}`;
      window.fathom.trackPageview({ url: locationWithKey.toString() });
    }
  }, [key]);

  useEffect(() => {
    if (elementRef.current) {
      const { top, left } = elementRef.current.getBoundingClientRect();
      window.scrollTo({ top, left });
    }
  }, [key, elementRef]);

  return (
    <main
      className={clsx("survey-page", className, htmlAttributes.class)}
      ref={elementRef}
    >
      <form action="" className="survey-page__form" onSubmit={handleSave}>
        <Progress onBackButton={onPreviousPage} step={stepForPageKey(key)} />
        {(title || description) && (
          <div className="survey-page__intro">
            {title && <h1 className="survey-page__title">{title}</h1>}
            {description && <p className="survey-page__text">{description}</p>}
          </div>
        )}

        {children}

        <button className="survey-page__action">
          {i18n.t("general.next_page")}
        </button>
      </form>
    </main>
  );
}
